import React, { useEffect } from 'react';
import { Button, Icon } from '@tencent/tea-component';
import './HostTips.scss';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getSelfInfo } from '@store/user/user.slice';
import { WeMeetClient } from '@tencent/wemeet-websdk-next';
import { changeIfShowHostTips, getIfShowHostTips } from '@store/ui/ui.slice';

const HostTips: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const user = useAppSelector(getSelfInfo);
  const showTips = useAppSelector(getIfShowHostTips);

  const isHost = WeMeetClient.utils.isHost(user);

  const onDownload = () => {
    window.open('https://voovmeeting.com/download-center.html?from=1001');
  };

  useEffect(() => {
    dispatch(changeIfShowHostTips(isHost));
  }, [isHost]);

  if (!showTips) {
    return null;
  }
  return (
    <div className="cpn-host-tips">
      <div className="cpn-host-tips__left">{t('您是这场会议的主持人，请使用客户端版本使用更多管理功能')}</div>
      <Button onClick={onDownload} className="cpn-host-tips__right" type="primary">
        {t('下载')}
      </Button>
      <Icon
        className="cpn-host-tips__close"
        type="close"
        size="s"
        onClick={() => dispatch(changeIfShowHostTips(false))}
      />
    </div>
  );
};

export default React.memo(HostTips);
